import Arrow from "../assets/arrow.svg";

export default function CareerSlide({
  tag,
  reverse,
  min_height,
  font_size,
  title,
  text,
  link,
  bgDesktop,
  bgMobile,
  className,
}) {
  return (
    <section
      className={[
        "relative bg-gray-200 py-16 min-w-full flex flex-col",
        min_height,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div
        className={[
          "relative z-20 container lg:m-auto lg:flex lg:items-center",
          reverse ? "lg:flex-row-reverse" : "lg:flex-row",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={["lg:w-2/5", reverse ? "lg:mr-24" : "lg:ml-10"]
            .filter(Boolean)
            .join(" ")}
        >
          {tag && (
            <p className="text-base text-blue-400 font-bold leading-6 md:text-2xl md:leading-8">
              {tag}
            </p>
          )}

          {title && (
            <h2
              className={`text-blue-700 font-medium my-2 ${font_size.header}`}
            >
              {title}
            </h2>
          )}

          <hr className="border-3 border-blue-400 bg-blue-400 rounded w-1/4 my-4 lg:w-1/6" />

          <p className={`leading-6 text-base text-blue-700 ${font_size.text}`}>
            {text}
          </p>

          {link && link.url && link.title && (
            <a
              href={link.url}
              target={link.opensInNewTab ? '_blank' : '_self'}
              rel={link.opensInNewTab ? 'noopener noreferrer' : ''}
              className="leading-8 text-xl text-blue-700 font-bold flex items-center mt-6 md:text-3xl md:leading-8"
            >
              <span>{link.title}</span>
              <Arrow className={"w-3 h-3 transform rtl:rotate-90 -rotate-90 mr-1 md:h-6 md:w-6"} />
            </a>
          )}
        </div>
        {bgDesktop && (
          <div className="hidden lg:flex mt-12 lg:mt-0 lg:w-3/5">
            <div className="lg:w-222 flex flex-row-reverse">
              <img className="object-cover w-full lg:w-auto" src={bgDesktop} alt="" />
            </div>
          </div>
        )}
        {bgMobile && (
          <div className="lg:hidden mt-12">
            <div className="flex flex-row-reverse">
              <img className="object-cover w-full" src={bgMobile} alt="" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
